<template>
  <v-bottom-navigation
    v-model="value"
    grow
    fixed
    color="white"
    class="bottomnav"
    dark
  >
    <v-btn value="temps">
      <span>Temps</span>
      <v-icon>mdi-weather-partly-cloudy</v-icon>
    </v-btn>

    <v-btn value="analisi">
      <span>Anàlisi</span>
      <v-icon>mdi-chart-bar</v-icon>
    </v-btn>

    <v-btn value="mapes">
      <span>Mapes</span>
      <v-icon>mdi-map-marker</v-icon>
    </v-btn>

    <v-btn value="dades">
      <span>Dades</span>
      <v-icon>mdi-database</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
 import Utils from '../utils'

 export default {
   data: () => ({
     value: 'temps',
   }),

   computed: {
     isMobile() {
       this.screen;
       return Utils.isMobile();
     },
   },

   watch: {
     value(to, from) {
       if (to != from)
         this.$router.push(to);
     }
   }
 } 
</script>

<style>
 .bottomnav {
   background-color: #880016 !important;
 }
</style>
